import { ApplicationEnum } from '@landr/core.models';
import { Heading } from '@landr/maestro';
import {
    Environment,
    Languages,
    PricingProvider,
    ChromaticPricing,
    PricingTabsEnum,
    BillingCommitment,
} from '@landr/pricing';
import { getTwoLetterLanguageCode } from 'helpers';
import React from 'react';
import { PageContextType } from 'types';
import { getCheckoutLinkFromPlanCode } from 'helpers/pricingLinkUtils';
import { useAnchorScroll } from 'hooks';
import { log } from '../../../log';
import { SupportedPrismicSlicesEnum } from '../enums';
import { StyledPricingContentBox } from '../Pricing/styled';

const logger = log.getInstance('ChromaticPricingTab');

export type ChromaticPricingSliceProps = {
    pageContext: PageContextType;
    location: Location;
    slice: {
        type: SupportedPrismicSlicesEnum.chromatic_pricing;
        primary: {
            /* eslint-disable @typescript-eslint/naming-convention */
            chromatic_pricing_title: any;
        };
    };
};

export const ChromaticPricingSlice: React.FC<ChromaticPricingSliceProps> = ({ slice, location, pageContext }) => {
    /* eslint-disable @typescript-eslint/naming-convention */
    const language = getTwoLetterLanguageCode(pageContext.lang) as Languages;

    const pricingAnchor = 'pricing';
    const chromaticPricingRef: React.RefObject<any> = React.createRef();
    useAnchorScroll(pricingAnchor, chromaticPricingRef);

    const handleSubscriptionPurchase = ({
        code,
        commitment,
        couponCode,
    }: {
        code: string;
        commitment: BillingCommitment;
        couponCode?: string;
    }) => {
        typeof window !== 'undefined' &&
            window.open(
                getCheckoutLinkFromPlanCode({
                    code,
                    commitment,
                    couponCode,
                    homePage: 'Chromatic',
                    currentTab: PricingTabsEnum.Chromatic,
                    language,
                }),
                '_self',
            );
    };

    const { chromatic_pricing_title } = slice.primary;

    return (
        <PricingProvider
            applicationName={ApplicationEnum.GuestSite}
            env={process.env.GATSBY_ENV as Environment}
            language={language}
            log={logger}
            locationPathname={location.pathname}
            onSubscriptionPurchase={handleSubscriptionPurchase}
        >
            <StyledPricingContentBox id={pricingAnchor} ref={chromaticPricingRef} isCentered>
                <Heading as="h1" size="jb" maxWidth="1200px" pb={'xl'} mt={'xl'}>
                    {chromatic_pricing_title[0].text}
                </Heading>
                <ChromaticPricing />
            </StyledPricingContentBox>
        </PricingProvider>
    );
};
